import { render, staticRenderFns } from "./PageDeGarde.vue?vue&type=template&id=5f80adc1&scoped=true"
import script from "./PageDeGarde.vue?vue&type=script&lang=js"
export * from "./PageDeGarde.vue?vue&type=script&lang=js"
import style0 from "./PageDeGarde.vue?vue&type=style&index=0&id=5f80adc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f80adc1",
  null
  
)

export default component.exports